import {
  GET_PRODUCTION_STRUMIS_PRODUCTION_WORK_ORDER_PROCESSES
} from "./actions";

export function ProductionStrumisWorkOrderProductionProcesses (state = {}, action) {
  switch (action.type) {
    case `${GET_PRODUCTION_STRUMIS_PRODUCTION_WORK_ORDER_PROCESSES}_FULFILLED`: {
      return action.payload.data;
    }
    default:
      return state;
  }
}

